import { DataGrid, } from "devextreme-react";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDataSource } from "../../../contexts/dataSource";
import { useAuth } from "../../../contexts/auth";
import { getPropsDataGrid } from "../../../utils/default-props";
import { Column, ColumnChooser, FilterPanel, FilterRow, HeaderFilter, SearchPanel, Toolbar } from "devextreme-react/data-grid";
import { Item } from "devextreme-react/form";
import { getDataGridCustomToolbarCaption } from "../../../components/default-components/data-grid-custom-toolbar";
import { usePublicEvents } from "../../../contexts/public-events";
import { useNavigate } from "react-router-dom";


function SalaryAdvanceList() {
    //#region useStates
    const [id, setId] = useState()
    //#endregion

    //#region hooks
    const { dataSourceHR } = useDataSource()
    const { user } = useAuth()
    const dataGridRef = useRef()
    const { setPublicAddEvent } = usePublicEvents()
    const navigate = useNavigate();
    //#endregion

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeAdvance`,
        insertUrl: "/api/EmployeeAdvance/FormData"
    }), [user])


    const dateEditorOption = {
        type: "date",
        showClearButton: true,
        useMaskBehavior: true,
        displayFormat: "dd.MM.yyyy",
    }
    
    const onFocusedRowChanged = (e) => {
        setId(e.component.option('focusedRowKey'));
    }

    const handleAdd = useCallback((e) => {
        navigate('/salary-advance/salary-advance-card')
    }, [])

    const handleEdit = useCallback((e) => {
        navigate(`/salary-advance/salary-advance-card/${id}`)
    }, [id])

    useEffect(() => {
        setPublicAddEvent(() => handleAdd)

        return () => {
            setPublicAddEvent(undefined)
        }
    }, [handleAdd])

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <DataGrid
                        ref={dataGridRef}
                        dataSource={dataSource}
                        {...getPropsDataGrid}
                        focusedRowKey={id}
                        onFocusedRowChanged={onFocusedRowChanged}
                        onCellDblClick={handleEdit}
                    >
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <HeaderFilter />
                        <SearchPanel visible />
                        <ColumnChooser enabled />
                        {/* <KeyboardNavigation enterKeyAction={"moveFocus"} enterKeyDirection={"row"} /> */}
                        <Toolbar>
                            {getDataGridCustomToolbarCaption("Maaş Avansları Listesi")}
                            <Item name="searchPanel" />
                            <Item name="columnChooserButton" />
                            <Item name="addRowButton" />
                        </Toolbar>

                        <Column dataField="employeeFullname" caption="Personel İsim Soyisim" />
                        <Column dataField="requestDate" caption="Avans Talep Tarihi" 
                            editorType="dxDateBox"
                            editorOptions={dateEditorOption}
                            dataType="date"
                            format="shortDate" />
                        <Column dataField="voucherNumber" caption="Fiş Numarası" />
                        <Column dataField="purpose" caption="Avans Amacı" />
                        <Column dataField="requestAmount" caption="Avans Miktarı"/>
                        <Column dataField="isInstallmentRequested" caption="Taksit Durumu" />
                        <Column dataField="numberOfInstallments" caption="Taksit Adeti" />
                        <Column dataField="approvalStatus" caption="Onay Durumu" />
                        <Column dataField="approvalDate" caption="Onay Tarihi"
                            editorType="dxDateBox"
                            editorOptions={dateEditorOption}
                            dataType="datetime"
                            format="shortDateShortTime" />
                    </DataGrid>
                </div>
            </div>

        </React.Fragment >
    )
}

export default React.memo(SalaryAdvanceList)